import React, { useState, useEffect } from 'react';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <>
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-prussian-blue/95 backdrop-blur-md shadow-lg' : 'bg-lapis-lazuli/80'
      } rounded-full mx-4 md:mx-6 mt-4`}>
        <nav className="container mx-auto px-4 md:px-6 py-4">
          <div className="flex justify-between items-center">
            {/* Logo with new colors */}
            <div className="text-xl md:text-2xl font-bold text-white">
              مدرسة المميز
            </div>
            
            {/* Desktop Menu */}
            <div className="hidden md:flex items-center space-x-8 space-x-reverse">
              <button 
                onClick={() => scrollToSection('philosophy')}
                className="text-alice-blue hover:text-white transition-colors duration-300 font-medium"
              >
                منهجنا
              </button>
              <button 
                onClick={() => scrollToSection('journey')}
                className="text-alice-blue hover:text-white transition-colors duration-300 font-medium"
              >
                الحصص
              </button>
              <button 
                onClick={() => scrollToSection('requirements')}
                className="text-alice-blue hover:text-white transition-colors duration-300 font-medium"
              >
                المتطلبات
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="bg-celestial-blue hover:bg-celestial-blue/90 text-white font-bold py-2 px-6 rounded-full transition-all duration-300"
              >
                ابدئي رحلتكِ
              </button>
            </div>
            
            {/* Mobile Menu Button */}
            <div className="md:hidden">
              <button 
                onClick={toggleMenu}
                className="text-white focus:outline-none p-2 relative z-[60]"
              >
                <div className={`w-6 h-0.5 bg-white transition-all duration-300 ${isMenuOpen ? 'rotate-45 translate-y-2' : ''}`}></div>
                <div className={`w-6 h-0.5 bg-white my-2 transition-all duration-300 ${isMenuOpen ? 'opacity-0' : ''}`}></div>
                <div className={`w-6 h-0.5 bg-white transition-all duration-300 ${isMenuOpen ? '-rotate-45 -translate-y-2' : ''}`}></div>
              </button>
            </div>
          </div>
        </nav>
      </header>
      
      {/* Mobile Menu */}
      <div 
        className={`md:hidden fixed inset-0 w-full h-full bg-gradient-to-br from-prussian-blue via-lapis-lazuli to-cerulean z-[55] transition-all duration-300 ${
          isMenuOpen ? 'opacity-100 visible' : 'opacity-0 invisible'
        }`}
        onClick={closeMenu}
      >
        {/* Header bar in menu with close button */}
        <div className="fixed top-0 left-0 right-0 z-[60] rounded-full mx-4 mt-4 bg-lapis-lazuli/80">
          <div className="container mx-auto px-4 py-4">
            <div className="flex justify-between items-center">
              {/* Logo */}
              <div className="text-xl font-bold text-white">
                مدرسة المميز
              </div>
              
              {/* Close Button */}
              <button 
                onClick={closeMenu}
                className="text-white focus:outline-none p-2"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>
        </div>

        <div className="w-full h-full flex flex-col justify-center items-center space-y-10 px-6" onClick={(e) => e.stopPropagation()}>
          <button 
            onClick={() => scrollToSection('philosophy')}
            className="text-3xl text-alice-blue hover:text-white font-medium transition-colors duration-300"
          >
            منهجنا
          </button>
          <button 
            onClick={() => scrollToSection('journey')}
            className="text-3xl text-alice-blue hover:text-white font-medium transition-colors duration-300"
          >
            الحصص
          </button>
          <button 
            onClick={() => scrollToSection('requirements')}
            className="text-3xl text-alice-blue hover:text-white font-medium transition-colors duration-300"
          >
            المتطلبات
          </button>
          <button 
            onClick={() => scrollToSection('contact')}
            className="bg-celestial-blue hover:bg-celestial-blue/90 text-white font-bold py-5 px-14 rounded-full text-2xl transition-all duration-300 shadow-2xl"
          >
            ابدئي رحلتكِ
          </button>
        </div>
      </div>
    </>
  );
};

export default Header; 